import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation updateHolidayCalendarEntryMutation($input: UpdateHolidayCalendarEntryInput!) {
		updateHolidayCalendarEntry(input: $input) {
			holidayCalendarEntry {
				...settingsHolidayCalendars_holidayCalendarEntry
			}
		}
	}
`;

function getConfigs() {
	return [];
}

function getOptimisticResponse(input) {
	const holidayCalendarEntry = {id: input.id};
	if (input.name) {
		holidayCalendarEntry.name = input.name;
	}
	if (input.year != null) {
		holidayCalendarEntry.year = input.year;
		holidayCalendarEntry.month = input.month;
		holidayCalendarEntry.day = input.day;
	}
	return {
		updateHolidayCalendarEntry: {
			holidayCalendarEntry: holidayCalendarEntry,
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	const changes = [];

	for (const key of Object.keys(input)) {
		if (['id'].includes(key) || input[key] === undefined) {
			continue;
		}

		changes.push(key);
	}

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		configs: getConfigs(),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
